import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import './WhoWeServe.css';

const WhoWeServe = () => {
  const [titleRef, titleVisible] = useScrollAnimation();
  const [cardsRef, cardsVisible] = useScrollAnimation({ threshold: 0.1 });

  return (
    <section className="who-we-serve">
      <h2 
        ref={titleRef}
        className={`section-title ${titleVisible ? 'animate-in' : ''}`}
      >
        Who We Work With
      </h2>
      <div 
        ref={cardsRef}
        className={`cards-container ${cardsVisible ? 'animate-in' : ''}`}
      >
        <div className="serve-card">
          <div className="card-icon">
            <svg viewBox="0 0 100 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="25" cy="20" r="8" stroke="#0066CC" strokeWidth="2" strokeDasharray="3 3" fill="none"/>
              <circle cx="50" cy="20" r="8" stroke="#0066CC" strokeWidth="2" strokeDasharray="3 3" fill="none"/>
              <circle cx="75" cy="20" r="8" stroke="#0066CC" strokeWidth="2" strokeDasharray="3 3" fill="none"/>
              <path d="M 15 30 Q 25 40 25 50 Q 25 60 35 60 L 65 60 Q 75 60 75 50 Q 75 40 85 30" 
                    stroke="#0066CC" strokeWidth="2" strokeDasharray="3 3" fill="none"/>
            </svg>
          </div>
          <h3 className="card-title">Medical professionals and practice owners</h3>
        </div>

        <div className="serve-card">
          <div className="card-icon">
            <svg viewBox="0 0 100 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="30" y="25" width="40" height="30" stroke="#0066CC" strokeWidth="2" strokeDasharray="3 3" fill="none" rx="3"/>
              <rect x="35" y="30" width="30" height="20" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none" rx="2"/>
              <circle cx="45" cy="15" r="4" stroke="#0066CC" strokeWidth="2" strokeDasharray="3 3" fill="none"/>
              <circle cx="55" cy="15" r="4" stroke="#0066CC" strokeWidth="2" strokeDasharray="3 3" fill="none"/>
              <path d="M 40 15 L 40 25 M 60 15 L 60 25" stroke="#0066CC" strokeWidth="2" strokeDasharray="3 3"/>
            </svg>
          </div>
          <h3 className="card-title">Incorporated and self-employed professionals</h3>
        </div>

        <div className="serve-card">
          <div className="card-icon">
            <svg viewBox="0 0 100 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="15" y="20" width="30" height="50" stroke="#0066CC" strokeWidth="2" strokeDasharray="3 3" fill="none" rx="2"/>
              <rect x="20" y="30" width="8" height="8" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              <rect x="32" y="30" width="8" height="8" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              <rect x="20" y="42" width="8" height="8" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              <rect x="32" y="42" width="8" height="8" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              <rect x="20" y="54" width="8" height="8" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              <rect x="32" y="54" width="8" height="8" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              <rect x="20" y="66" width="8" height="8" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              <rect x="32" y="66" width="8" height="8" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              
              <rect x="55" y="35" width="30" height="35" stroke="#0066CC" strokeWidth="2" strokeDasharray="3 3" fill="none" rx="2"/>
              <rect x="60" y="45" width="8" height="8" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              <rect x="72" y="45" width="8" height="8" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              <rect x="60" y="57" width="8" height="8" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              <rect x="72" y="57" width="8" height="8" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              <rect x="60" y="69" width="8" height="8" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              <rect x="72" y="69" width="8" height="8" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
            </svg>
          </div>
          <h3 className="card-title">Business owners</h3>
        </div>

        <div className="serve-card">
          <div className="card-icon">
            <svg viewBox="0 0 100 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="20" y="30" width="60" height="40" stroke="#0066CC" strokeWidth="2" strokeDasharray="3 3" fill="none" rx="2"/>
              <rect x="30" y="40" width="15" height="20" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              <rect x="55" y="40" width="15" height="20" stroke="#0066CC" strokeWidth="1.5" strokeDasharray="2 2" fill="none"/>
              <path d="M 20 30 L 50 15 L 80 30" stroke="#0066CC" strokeWidth="2" strokeDasharray="3 3" fill="none"/>
            </svg>
          </div>
          <h3 className="card-title">Homeowners approaching mortgage renewal or refinancing</h3>
        </div>
      </div>
    </section>
  );
};

export default WhoWeServe;
